import { useStorage, useSessionStorage } from '@vueuse/core'

import { StorageKeys } from '@/constants/commons'

import { PaymentMethodsType } from '@/types/payment'
import type { SearchRecordItem } from '@/types/search'

export function useFirstTimePurchaseStorage() {
  const isFirstTimePurchase = useStorage(StorageKeys.FIRST_TIME_PURCHASE, true)

  return { isFirstTimePurchase }
}

export function useSmSValidationStorage() {
  const lastValidationTime = useStorage(StorageKeys.SMS_VALIDATION_EXPIRED_AT, 0)

  return { lastValidationTime }
}

export function useLastPaymentGatewayStorage() {
  return useStorage<PaymentMethodsType>(StorageKeys.LAST_PAYMENT_GATEWAY, PaymentMethodsType.NONE)
}

export function useSearchRecordsStorage() {
  return useStorage<Record<string, SearchRecordItem[] | string[]>>(StorageKeys.SEARCH_RECORDS, {})
}

export function useSiteIdStorage() {
  return useSessionStorage(StorageKeys.SITE_ID, '')
}
